export class FormErrors {
    /**
     * Create a new FormErrors instance
     */
    constructor() {
        this.errors = {};
    }

    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} attribute
     */
    has(attribute) {
        return this.errors.hasOwnProperty(attribute);
    }

    /**
     * Determine if we have any errors.
     *
     * @returns {boolean}
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }

    /**
     * Retrieve the error message for a field.
     *
     * @param {string} attribute
     */
    get(attribute) {
        if (this.has(attribute)) {
            return this.errors[attribute][0];
        }
    }

    /**
     * Set the new errors
     *
     * @param {object} errors
     */
    set(errors) {
        this.errors = errors;
    }

    /**
     * Set the new errors
     *
     * @param {string} attribute
     * @param {string} error
     */
    add(attribute, error) {
        this.errors[attribute] = [error];
    }

    /**
     * Clear one or all error fields.
     *
     * @param {string|null} attribute
     */
    clear(attribute) {
        if (attribute) {
            delete this.errors[attribute];

            return;
        }

        this.set({});
    }
}